<template>
  <div class="tag" :class="{ 'dark' : darkTheme }">
    <span class="tag-name">{{ name }}</span>
    <button v-if="!viewOnly" type="button" class="tag-remove" @click="onRemove">
      <ag-icon width="16" height="16">
        <x-icon />
      </ag-icon>
    </button>
  </div>
</template>

<script>
  import XIcon from "./icons/XIcon";

  export default {
    name: "Tag",
    props: {
      id: {
        type: Number,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      darkTheme: {
        type: Boolean,
        default: false
      },
      viewOnly: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onRemove() {
        this.$emit("remove", this.id);
      }
    },
    components: { XIcon }
  };
</script>

<style scoped lang="scss">
  .tag {
    background: $color-white;
    border: $border;
    border-radius: $radius;
    box-shadow: $shadow;
    display: inline-flex;
    align-items: center;
    line-height: 1.1em;

    &.dark {
      border-color: #2E2E2E;
      background: #1C1C1C;
      color: $color-white;
    }

    .tag-name {
      flex-grow: 1;
      padding: 8px 16px;
    }

    .tag-remove {
      padding: 8px 12px;
      border: 0;
      border-left: 1px solid $color-gray-medium;
      background: transparent;
      min-width: 0;
      border-radius: 0;
      box-shadow: none;

      svg {
        fill: $color-gray;
        display: block;
      }

      &:hover {
        background: rgba(0,0,0,0.03);

        svg {
          fill: $color-secondary;
        }
      }
    }
  }
</style>
